import { useMemo } from 'react'
import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { getSelectOptions } from 'utils/getSelectOptions'

interface IUseSelectOptionsProps<T> {
  options: T[]
  mapOption: (item: T) => TSelectOpt
}

/**
 * Helper to quickly map items to TSelectOpt type
 * @example
 * ```
 * const options = useSelectOptions({
 *   options: [{ id: '1', name: 'One' }, { id: '2', name: 'Two' }],
 *   mapOption: ({ id, name }) => ({ value: id, label: name })
 * })
 * ```
 */
export function useSelectOptions<T>({
  options: optionsProp = [],
  mapOption,
}: IUseSelectOptionsProps<T>) {
  const options = useMemo(() => {
    return getSelectOptions<T>({
      options: optionsProp,
      mapOption,
    })
  }, [mapOption, optionsProp])

  return {
    options,
  }
}
